import React from "react";
import { useSelector } from "react-redux";
import lodashGet from "lodash/get";

import { MuiTable as Table } from "@jazasoft/mui-table";
import { getDistinctValues, isEmpty, isTrue } from "../utils/helpers";

const defaultHighlightColor = "#fcfae8";

const MuiTable = ({ i18nKey, columns, highlightColor = defaultHighlightColor, ...props }) => {
  const messages = useSelector(state => state?.i18n?.messages) || {};
  const { rows, parentIdKey } = props;
  const i18nMap = {
    ...messages?.muiTable,
    fields: i18nKey ? lodashGet(messages, i18nKey) : {}
  };

  const finalColumns = columns.map(({ render, ...column }) => {
    if (isTrue(column?.highlight)) {
      return {
        ...column,
        render: (value, shortValue, row) => {
          const siblings = isEmpty(row[parentIdKey])
            ? rows.filter(r => isEmpty(r[parentIdKey]))
            : rows.filter(r => r[parentIdKey] === row[parentIdKey]);
          const colValues = getDistinctValues(siblings.filter(r => !isEmpty(r[column.dataKey])).map(r => r[column.dataKey]));
          let hColor = "";
          if (colValues.length > 1) {
            hColor = Array.isArray(highlightColor) ? highlightColor[row.level] || highlightColor[0] || defaultHighlightColor : highlightColor;
          }
          return (
            <span style={{ backgroundColor: !isEmpty(value) ? hColor : undefined, padding: "2px 6px", borderRadius: 4 }}>
              {typeof render === "function" ? render(value, shortValue, row) : shortValue}
            </span>
          );
        }
      };
    }
    return { ...column, render };
  });

  return <Table fontSize={16} toolbarStyle={{ minHeight: 48 }} {...props} columns={finalColumns} i18nMap={i18nMap} />;
};

export default MuiTable;
